// Imports
var ___CSS_LOADER_API_IMPORT___ = require("C:\\Users\\admin\\AppData\\Roaming\\npm\\node_modules\\expo-cli\\node_modules\\css-loader\\dist\\runtime\\api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-form-builder .react-form-builder-preview.is-editing .edit-form {\r\n    left: 200px;\r\n}", ""]);
// Exports
module.exports = exports;
